var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("icon icon--" + _vm.icon)},[_c('svg',[(_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('use',{attrs:{"xlink:href":("#icon--" + _vm.icon)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }